import * as api from './api';

const TABLE = 'customers';
const PK = 'id';

export const fetchCustomers = (searchTerm = '') =>
  api.fetchRecords(TABLE, {
    searchField: 'full_name',
    searchTerm,
    orderBy: { field: 'customer_no', ascending: true },
  });

export const createCustomer = (data) => {
  const { [PK]: _id, ...payload } = data;   // strip auto-increment PK
  return api.createRecord(TABLE, payload);
};

export const updateCustomer = (id, data) =>
  api.updateRecord(TABLE, PK, id, data);

export const deleteCustomer = (id) =>
  api.deleteRecord(TABLE, PK, id);
